import job_details_0 from "file:///home/wldocker/wl-cms/sites/modules/job-details-widget/ui/src/job-details.js";job_details_0();